import { gql } from '@apollo/client';

// Update user profile graphql
export const UPDATE_USER_PROFILE = gql`
  mutation UPDATE_USER(
    $name: String
    $firstName: String
    $lastName: String
    $bio: String
    $website: String
    $collaborationStatus: String
    $isOnboarded: Boolean
    $country: String
    $city: String
    $userInterests: [String!]
    $skills: [String!]
    $professions: [String!]
    $locations: [String!]
  ) {
    editUserProfile(
      name: $name
      firstName: $firstName
      lastName: $lastName
      bio: $bio
      website: $website
      collaborationStatus: $collaborationStatus
      isOnboarded: $isOnboarded
      country: $country
      city: $city
      userInterests: $userInterests
      skills: $skills
      professions: $professions
      locations: $locations
    ) {
      id
      isOnboarded
      userInterests
      profile {
        id
        name
        firstName
        lastName
        bio
        website
        collaborationStatus
        country
        city
      }
      skills {
        id
        name
      }
      professions {
        id
        name
      }
    }
  }
`;
